import { Context } from "./style";

type ContainerProps = {
  children: React.ReactNode;
};

export default function Container({ children }: ContainerProps) {
  return <Context>{children}</Context>;
}
